// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__37l2_","textarea":"styles_textarea__39ZUr"};